<app-users-admin [typeOfView]='typeOfView'></app-users-admin>
